export function getTypeFromUrl(url) {
  let type = '';
  if (url) {
    const arr = url?.split('?')[0]?.split('.');
    type = arr[arr.length - 1];
  }

  return type;
}
